import { useMemo } from "react";
import { View, Flex, Text } from "@adobe/react-spectrum";
import {
  formatTime,
  getCallbackIcon,
  getInitialsAndColor,
} from "../../../utils";
import { CALLBACK } from "../../../constants/constants";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { MissedCallIcon } from "../Icons";

interface CVHistorySidebarProps {
  activeCallerId: string;
  getActiveCallId: (id: string) => void;
  callList: any[];
  type: "callback" | "voicemail";
}

const CVHistorySidebar = ({
  activeCallerId,
  getActiveCallId,
  callList,
  type,
}: CVHistorySidebarProps) => {
  const common = useSelector((state: RootState) => state.common);

  const computedCallList = useMemo(() => {
    return callList?.map((call) => ({
      ...call,
      initialsData:
        type === CALLBACK
          ? getInitialsAndColor(
              call.customer.attributes.FIRSTNAME[0] +
                " " +
                call.customer.attributes.LASTNAME[0]
            )
          : getInitialsAndColor("N A"),
    }));
  }, [callList, type]);

  return (
    <View
      UNSAFE_className="call-history-sidebar"
      borderTopColor={"gray-200"}
      borderTopWidth={"thick"}
      height={"100%"}
    >
      {computedCallList?.length > 0 &&
        computedCallList.map((call) => {
          const { connectedTime, endTime, missed } = call?.self || {};
          const { formattedConnectedTime, formattedDifference } = formatTime(
            connectedTime,
            endTime
          );
          const { initials, backgroundColor } = call.initialsData;

          return (
            <div
              key={call.id}
              onClick={() => getActiveCallId(call.id)}
              className="call-history-sidebar-list"
            >
              <Flex
                flexGrow={1}
                justifyContent={"space-between"}
                direction={"column"}
                UNSAFE_className={`call-history-sidebar-list-item ${
                  call.id === activeCallerId
                    ? " call-history-sidebar-list-active"
                    : ""
                }`}
              >
                <Flex>
                  <Flex UNSAFE_style={{ paddingRight: "12px" }}>
                    <View UNSAFE_className="call-history-avatar">
                      <Flex
                        justifyContent="center"
                        alignItems="center"
                        UNSAFE_className="agent-avatar"
                        UNSAFE_style={{
                          backgroundColor,
                          borderRadius: "50%",
                        }}
                      >
                        <Text UNSAFE_className="call-monitor-agent-text">
                          {initials}
                        </Text>
                      </Flex>
                    </View>
                  </Flex>
                  <Flex
                    width={"100%"}
                    alignItems={"end"}
                    justifyContent={"space-between"}
                  >
                    <Flex
                      direction="column"
                      alignItems="start"
                      UNSAFE_className="call-detail-history-list"
                    >
                      <Text UNSAFE_className="call-history-title">
                        {call?.customer?.attributes.PHONE_NUMBER || "-"}
                      </Text>
                      <Text
                        UNSAFE_style={{ textAlign: "start", color: "#D7373F" }}
                      >
                        <Flex
                          UNSAFE_className={`call-history-subtitle ${
                            missed ? "call-missed" : "call-attend"
                          }`}
                          alignItems={"center"}
                          justifyContent={"center"}
                          marginTop={5}
                        >
                          {call?.self.missed && common?.tab === "History" ? (
                            <Text marginX={5}>
                              <MissedCallIcon />
                            </Text>
                          ) : (
                            <img
                              src={getCallbackIcon()}
                              className="call-history-icon"
                              alt="Missed call icon"
                            />
                          )}
                          <Text
                            marginX={5}
                            UNSAFE_style={{ whiteSpace: "nowrap" }}
                          >
                            {formattedConnectedTime}
                          </Text>
                        </Flex>
                      </Text>
                    </Flex>
                    {!call?.self.missed && (
                      <Flex direction="column">
                        <Text UNSAFE_className="call-history-time-diff">
                          {formattedDifference}
                        </Text>
                      </Flex>
                    )}
                  </Flex>
                </Flex>
              </Flex>
            </div>
          );
        })}
    </View>
  );
};

export default CVHistorySidebar;
